import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CardsRoutingModule } from './cards-routing.module';
import { AddcategoryComponent } from './category/addcategory/addcategory.component';
import { CategorylstComponent } from './category/categorylst/categorylst.component';
import { AddsubcategoryComponent } from './subcategory/addsubcategory/addsubcategory.component';
import { SubcategorylstComponent } from './subcategory/subcategorylst/subcategorylst.component';
import { AddproductComponent } from './product/addproduct/addproduct.component';
import { ProductlstComponent } from './product/productlst/productlst.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { A11yModule } from '@angular/cdk/a11y';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { CategoryService } from './category/category.service';
import { SubcategoryService } from './subcategory/subcategory.service';
import { ProductService } from './product/product.service';
import { Globle } from 'src/assets/globle';
import { MatspinnerComponent } from './matspinner/matspinner.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { ExcelService } from './excel.service';
import { TranslateModule } from '@ngx-translate/core';
import { AddadvertizeComponent } from './advertize/addadvertize/addadvertize.component';
import { AdvertizelistComponent } from './advertize/advertizelist/advertizelist.component';
import { PaymentrequestlstComponent } from './paymentrequest/paymentrequestlst/paymentrequestlst.component';
import { PaymentrequestdetailsComponent } from './paymentrequest/paymentrequestdetails/paymentrequestdetails.component';
import { MatChipsModule } from '@angular/material/chips';
import { PaymentproviderlstComponent } from './paymentproviders/paymentproviderlst/paymentproviderlst.component';
import { PaymentproviderformComponent } from './paymentproviders/paymentproviderform/paymentproviderform.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgxSummernoteModule } from 'ngx-summernote';
import { GoodcardintcInterceptor } from '../goodcardintc.interceptor';
import { ProductcardsmanagmentComponent } from './productcardsmanagment/productcardsmanagment.component';
// export const MY_FORMATS = {
//   parse: {
//     dateInput: 'LL',
//   },
//   display: {
//     dateInput: 'DD/MM/YYYY',
//     monthYearLabel: 'YYYY',
//     dateA11yLabel: 'LL',
//     monthYearA11yLabel: 'YYYY',
//   },
// };

@NgModule({
  declarations: [
    AddcategoryComponent,
    CategorylstComponent,
    AddsubcategoryComponent,
    SubcategorylstComponent,
    AddproductComponent,
    ProductlstComponent,
    MatspinnerComponent,
    AddadvertizeComponent,
    AdvertizelistComponent,
    PaymentrequestlstComponent,
    PaymentrequestdetailsComponent,
    PaymentproviderlstComponent,
    PaymentproviderformComponent,
    ProductcardsmanagmentComponent
  ],
  imports: [
    CommonModule,
    CardsRoutingModule,
    FormsModule,
    HttpClientModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatDialogModule,
    MatGridListModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatSnackBarModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatRippleModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    A11yModule,
    TranslateModule,
    MatChipsModule,
    MatExpansionModule,
    // AngularEditorModule,
    NgxSummernoteModule
    // TranslateModule.forRoot({
    //   defaultLanguage:'ar',
    //   loader: {
    //     provide: TranslateLoader,
    //     useFactory: httpTranslateLoader,
    //     deps: [HttpClient],

    //   }
    // })
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GoodcardintcInterceptor,
      multi: true
    },
    CategoryService,
    SubcategoryService,
    ProductService,
    ExcelService,
    Globle
  ]
})
export class CardsModule { }
